import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getPaymentMethods } from "../redux/actions/PaymentActions";

// Tells whether the bank card can be offered, and its fee percentage.
// Used where the amount is not known by the server yet (no request created).
export default function useCardMethod() {
  const dispatch = useDispatch();
  const [method, setMethod] = useState({ available: false, feePercent: 0 });

  useEffect(() => {
    let active = true;

    dispatch(
      getPaymentMethods((response) => {
        if (active && response.success && response.data?.card) {
          setMethod({
            available: true,
            feePercent: response.data.cardFeePercent || 0,
          });
        }
      }),
    );

    return () => {
      active = false;
    };
  }, [dispatch]);

  return method;
}
